<template>
  <div class="page">
    <!-- 头部 -->
    <div class="page-header shadow">
      <div class="header-inner">
        <div class="label">内保单查询：</div>
        <div class="content">
          <el-input placeholder="请输入内保单流水号" v-model="keyword">
            <template slot="append"><i class="el-icon-search" @click="handleSearh"></i></template>
          </el-input>
        </div>
      </div>
    </div>
    <!-- 基本信息 -->
    <div class="base-info shadow">
      <el-form :model="bill_data" inline ref="bill_data" label-width="90px"
        class="demo-ruleForm">
        <el-form-item class="from-item--30" label="内保起期" prop="beginTime">
          <el-date-picker v-model="bill_data.beginTime" type="datetime" disabled placeholder="选择日期时间" :editable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="内保止期" prop="endTime">
          <el-date-picker v-model="bill_data.endTime" type="datetime" disabled placeholder="选择日期时间" :editable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="出单公司" prop="orgNo">
          <el-cascader filterable v-model="bill_data.orgNo" disabled :options="$store.state.app.orgList" :props="{
            children: 'children',
            label: 'orgName',
            value: 'id',
            checkStrictly: true,
            emitPath: false,
          }"></el-cascader>
        </el-form-item>
        <el-form-item class="from-item--30" label="业务员" prop="saleNo">
          <el-select v-model="bill_data.saleNo" disabled placeholder="请选择业务员" filterable>
            <el-option v-for="item in $store.state.app.salesmanList" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="交费方式" prop="payType">
          <el-select v-model="bill_data.payType" disabled placeholder="请选择交费方式">
            <el-option label="全费" value="全费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="经办人" prop="HandlerNo">
          <el-select v-model="bill_data.HandlerNo" disabled placeholder="请选择经办人" filterable>
            <el-option v-for="item in $store.state.app.userList" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--100" label="备注" prop="remark">
          <el-input type="textarea" :rows="3" disabled v-model="bill_data.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 信息 -->
    <el-tabs class="card-info shadow" type="border-card">
      <el-tab-pane label="申请信息">
        <el-form :model="formData" inline ref="car_data" label-width="100px" class="demo-ruleForm">
          <el-form-item class="from-item--30" label="车辆" prop="plate_num">
            <el-input v-model="formData.plate_num" placeholder="车辆" />
          </el-form-item>
          <el-form-item class="from-item--30" label="理赔员" prop="adjusters">
            <el-input v-model="formData.adjusters" placeholder="理赔员" />
          </el-form-item>
          <el-form-item class="from-item--30" label="创建时间" prop="createtime">
            <el-date-picker v-model="formData.createtime" type="datetime" placeholder="选择日期时间" :editable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="from-item--30 has-btn" label="姓名" prop="user_name">
            <el-input v-model="formData.user_name" placeholder="姓名" />
          </el-form-item>
          <el-form-item class="from-item--30" label="手机号" prop="mobile">
            <el-input v-model="formData.mobile" placeholder="手机号" />
          </el-form-item>
          <el-form-item class="from-item--30" label="事故地址" prop="store">
            <div style="display: flex;">
              <el-select v-model="formData.province_id" placeholder="请选择省" @change="provinceChange" filterable>
                <el-option v-for="item in plist" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select v-model="formData.city_id" placeholder="请选择市" @change="cityChange" filterable>
              <el-option v-for="item in slist" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select v-model="formData.district_id" placeholder="请选择区" filterable>
              <el-option v-for="item in qlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="from-item--30" label="详细地址" prop="address">
            <el-input v-model="formData.address" placeholder="事故地址" />
          </el-form-item>
          <el-form-item class="from-item--30" label="原因" prop="reason">
            <el-input v-model="formData.reason" placeholder="原因" />
          </el-form-item>
          <el-form-item class="from-item--30" label="受损部位" prop="info">
            <el-input v-model="formData.info" placeholder="受损部位" />
          </el-form-item>
          <el-form-item class="from-item--30" label="备注" prop="beizhu">
            <el-input v-model="formData.beizhu" placeholder="备注" />
          </el-form-item>
          <el-form-item class="from-item--30" label="状态" prop="status">
            <el-select v-model="formData.status" filterable>
              <el-option label="等待中" value="1"></el-option>
              <el-option label="事件受理" value="2"></el-option>
              <el-option label="定损维修" value="3"></el-option>
              <el-option label="完工交车" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="受理时间" prop="accepttime">
          <el-date-picker v-model="formData.accepttime" type="datetime" placeholder="选择日期时间" :editable="false">
          </el-date-picker>
          </el-form-item>
          <el-form-item class="from-item--10" label="事故照片" prop="accidentPhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="accidentPhoto" :limit="10"
              :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file,1)"
              :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList,1)
                ">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item class="from-item--10" label="受理照片" prop="acceptancePhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="acceptancePhoto" :limit="10"
              :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file,4)"
              :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList,4)
                ">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="维修信息">
        <el-form :model="formData" inline ref="car_data" label-width="100px" class="demo-ruleForm">
          <el-form-item class="from-item--30" label="维修厂" prop="store">
            <el-select v-model="formData.store_id" placeholder="请选择维修厂" filterable>
            <el-option v-for="item in $store.state.app.store" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item class="from-item--30" label="维修时间" prop="repairtime">
          <el-date-picker v-model="formData.repairtime" type="datetime" placeholder="选择日期时间" :editable="false">
          </el-date-picker>
          </el-form-item>
          <el-form-item class="from-item--10" label="维修照片" prop="repairPhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="repairPhoto" :limit="10"
              :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file,2)"
              :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList,2)
                ">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div style="display: flex;">
          <FoldedPanel style="width: 45%;margin-left: 3%;">
            <template #title>
              <span class="panel-header-text"><i class="icon el-icon-menu">维修项目</i></span>
            </template>
            <el-table :data="projectList" style="width: 100%">
              <el-table-column prop="name" min-width="100" label="项目">
                <template slot-scope="scope">
                  <div class="input-wrap">
                    <el-input v-model="scope.row.name" placeholder="项目名称"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money" min-width="100" label="工时(小时)">
                <template slot-scope="scope">
                  <div class="input-wrap">
                    <el-input v-model="scope.row.money" placeholder="项目工时"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="set" label="操作">
                <template slot-scope="scope">
                  <div class="input-wrap">
                    <el-button v-if="scope.$index == 0" size="mini" @click="handleAdd()">增加</el-button>
                    <el-button v-if="scope.$index > 0" size="mini" @click="handleDel(scope.$index)" type="danger">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </FoldedPanel>
          <FoldedPanel style="width: 45%;margin-left: 3%;">
            <template #title>
              <span class="panel-header-text"><i class="icon el-icon-menu">备件更换项目</i></span>
            </template>
            <el-table :data="partList" style="width: 100%">
              <el-table-column prop="name" min-width="100" label="项目">
                <template slot-scope="scope">
                  <div class="input-wrap">
                    <el-input v-model="scope.row.name" placeholder="项目名称"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money" min-width="100" label="金额(元)">
                <template slot-scope="scope">
                  <div class="input-wrap">
                    <el-input v-model="scope.row.money" placeholder="项目金额"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="set" label="操作">
                <template slot-scope="scope">
                  <div class="input-wrap">
                    <el-button v-if="scope.$index == 0" size="mini" @click="handlepartAdd()">增加</el-button>
                    <el-button v-if="scope.$index > 0" size="mini" @click="handlepartDel(scope.$index)" type="danger">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </FoldedPanel>
        <!-- <FoldedPanel style="width: 45%;margin-left: 3%;">
            <template #title>
              <span class="panel-header-text"><i class="icon el-icon-menu">维修项目</i></span>
            </template>
            <el-table :data="projectList" style="width: 100%">
              <el-table-column prop="isCheck" label="选择" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isCheck"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="name" min-width="200" label="项目">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="金额(元)">
                <template slot-scope="scope">
                  <span v-if="!scope.row.isCheck">{{scope.row.money}}元</span>
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    <el-input v-model="scope.row.money" placeholder="元">
                    </el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
        </FoldedPanel>
        <FoldedPanel style="width: 45%;margin-left: 4%;">
            <template #title>
              <span class="panel-header-text"><i class="icon el-icon-menu">备件更换项目</i></span>
            </template>
            <el-table :data="partList" style="width: 100%">
              <el-table-column prop="isCheck" label="选择" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isCheck"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="name" min-width="200" label="项目">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="金额(元)">
                <template slot-scope="scope">
                  <span v-if="!scope.row.isCheck">{{scope.row.money}}元</span>
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    <el-input v-model="scope.row.money" placeholder="元">
                    </el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
        </FoldedPanel> -->
      </div>
      </el-tab-pane>
      <el-tab-pane label="完工信息">
        <el-form :model="formData" inline ref="car_data" label-width="100px" class="demo-ruleForm">
          <el-form-item class="from-item--30" label="车损维修金额" prop="money">
            <el-input v-model="formData.money" placeholder="车损维修金额" />
          </el-form-item>
          <el-form-item class="from-item--30" label="三者金额" prop="money">
            <el-input v-model="formData.szmoney" placeholder="三者金额" />
          </el-form-item>
          <el-form-item class="from-item--30" label="责任认定比例" prop="money">
            <el-input v-model="formData.proportion" placeholder="责任认定比例" />
          </el-form-item>
          <el-form-item class="from-item--30" label="定损金额" prop="money">
            <el-input v-model="formData.amount" placeholder="定损金额" />
          </el-form-item>
          <el-form-item class="from-item--30" label="配件残值" prop="money">
            <el-input v-model="formData.accessories" placeholder="配件残值" />
          </el-form-item>
          <el-form-item class="from-item--30" label="完工时间" prop="endtime">
            <el-date-picker v-model="formData.endtime" type="datetime" placeholder="选择日期时间" :editable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="from-item--10" label="完工照片" prop="completedPhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="completedPhoto" :limit="10"
              :on-preview="handlePictureCardPreview" :on-change="(file) => handleChangeFile(file,3)"
              :auto-upload="false" :on-remove="(file, fileList) => handleRemoveImg(file, fileList,3)
                ">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="preVisible">
      <img width="100%" :src="preImageUrl" alt="" />
    </el-dialog>
    <div class="confirm">
      <el-button type="primary" @click="saveInfo">保存信息</el-button>
      <el-button type="info" @click="resetInfo">重置</el-button>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "Apply",
  comments: {},
  data() {
    return {
      keyword: "",
      preVisible: false,
      preImageUrl: "",
      bill_data: {},
      formData: {},
      // 附件相关
      accidentPhoto: [],
      repairPhoto: [],
      completedPhoto: [],
      acceptancePhoto: [],
      id:0,
      partList:[
        {name:'',money:''}
      ],
      projectList:[
        {name:'',money:''}
      ],
      plist:[],
      slist:[],
      qlist:[],
    };
  },
  computed: {},
  watch: {
    $route: {
      async handler(val) {
        const { id } = val.query;
        if (id) {
          this.id = id;
          await this.handleSearhDetail();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('app/getStore');
    this.getPlist();
    // if(this.id == 0){
    //   this.getProject();
    //   this.getPart();
    // }
    // 从客户列表进来的
    const { isCustomer, personName, certNo, tel, addr } = this.$route.query;
  },
  methods: {
    getToken,
    provinceChange(val){
      this.getSlist(val)
    },
    cityChange(val){
      this.getQlist(val)
    },
    async getPlist(){
      const res = await this.$api.post('/admin/accident/getArea', { id:0})
      this.plist = res.data
      this.getSlist(this.plist[0].id)
    },
    async getSlist(id){
      const res = await this.$api.post('/admin/accident/getArea', { id:id})
      this.slist = res.data
      this.getQlist(this.slist[0].id)
    },
    async getQlist(id){
      const res = await this.$api.post('/admin/accident/getArea', { id:id})
      this.qlist = res.data
    },
    handleAdd(){
        this.projectList.push({
          name: '',
          money: ''
        });
    },
    handleDel(key){
      this.projectList.splice(key,1);
    },
    handlepartAdd(){
        this.partList.push({
          name: '',
          money: ''
        });
    },
    handlepartDel(key){
      this.partList.splice(key,1);
    },
    // async getProject(){
    //   const res = await this.$api.post('/admin/repair/project', { status: 1,id:this.id})
    //   this.projectList = res.data.data
    // },
    // async getPart(){
    //   const res = await this.$api.post('/admin/repair/part', { status: 1,id:this.id})
    //   this.partList = res.data.data
    // },
    // 图片上传之前
    beforeUpload(file) {

    },
    // 回显详情
    async handleSearhDetail() {
      const res = await this.$api.post("/admin/accident/getDetails", {
        id: this.id,
      });
      this.accidentPhoto = res.data.accidentPhoto;
      this.repairPhoto = res.data.repairPhoto;
      this.completedPhoto = res.data.completedPhoto;
      this.acceptancePhoto = res.data.acceptancePhoto;
      if(res.data.projectList.length > 0){
        this.projectList = res.data.projectList;
      }
      if(res.data.partList.length > 0){
        this.partList = res.data.partList;
      }
      // 回显日志信息
      this.logs = res.data.log;
      this.bill_data = res.data.base
      this.bill_data.days = this.$tools.getDaysBetween(
          res.data.base.beginTime,
          res.data.base.endTime
        ),
      this.formData = res.data.data;
      this.keyword = this.formData.order_sn;
    },
    // 搜索详情
    async handleSearh() {
      let res = {};
      res = await this.$api.post("/admin/accident/getTheDetail", {
        keyword: this.keyword,
      });
      // 回显基本信息
      const billData = {
        ...res.data.base,
      };
      if (res.data.car) {
        this.formData.plate_num = res.data.car.carNo;
      }
      this.bill_data = {
          ...billData
      };
    },
    // 图片上传之前
    handlePictureCardPreview(file) {
        this.preImageUrl = file.url;
        this.preVisible = true;
    },
    // 删除图片
    handleRemoveImg(res, fileList, item) {
      if(item == 1){this.accidentPhoto = this.accidentPhoto.filter((el) => el.url !== res.url);}
      if(item == 2){this.repairPhoto = this.repairPhoto.filter((el) => el.url !== res.url);}
      if(item == 3){this.completedPhoto = this.completedPhoto.filter((el) => el.url !== res.url);}
      if(item == 4){this.acceptancePhoto = this.acceptancePhoto.filter((el) => el.url !== res.url);}
    },
    // 图片上传
    async handleChangeFile(file, item) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        if(item == 1){
          this.accidentPhoto.push({
            url: res.data.path,
          });
        }
        if(item == 2){
          this.repairPhoto.push({
            url: res.data.path,
          });
        }
        if(item == 3){
          this.completedPhoto.push({
            url: res.data.path,
          });
        }
        if(item == 4){
          this.acceptancePhoto.push({
            url: res.data.path,
          });
        }
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },

    uploadSuccess(res, item) {
      if (res.code === 10000) {
        this.$message.success("上传成功");
        this[item.prop].push({
          imageType: item.imageType,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
    },

    //保存内保信息
    async saveInfo() {
      if(this.keyword == ''){
        this.$message.warning("请输入内保单流水号");
        return;
      } else {
        this.formData.order_sn = this.keyword;
      }
      if(this.formData.plate_num == '' || !this.formData.plate_num){
        this.$message.warning("车辆不能为空");
        return;
      }
      if(this.formData.createtime == '' || !this.formData.createtime){
        this.$message.warning("创建时间不能为空");
        return;
      }
      if(this.formData.user_name == '' || !this.formData.user_name){
        this.$message.warning("姓名不能为空");
        return;
      }
      if(this.formData.mobile == '' || !this.formData.mobile){
        this.$message.warning("手机号不能为空");
        return;
      }
      if(this.formData.province_id == '' || !this.formData.province_id){
        this.$message.warning("请选择省");
        return;
      }
      if(this.formData.city_id == '' || !this.formData.city_id){
        this.$message.warning("请选择市");
        return;
      }
      if(this.formData.district_id == '' || !this.formData.district_id){
        this.$message.warning("请选择省区");
        return;
      }
      if(this.formData.address == '' || !this.formData.address){
        this.$message.warning("事故地址不能为空");
        return;
      }
      if(this.formData.reason == '' || !this.formData.reason){
        this.$message.warning("原因不能为空");
        return;
      }
      if(this.formData.info == '' || !this.formData.info){
        this.$message.warning("受损部位不能为空");
        return;
      }
      this.formData.projectList = [
        ...this.projectList,
      ];
      this.formData.partList = [
        ...this.partList,
      ];
      this.formData.accidentPhoto = [
        ...this.accidentPhoto,
      ];
      this.formData.repairPhoto = [
        ...this.repairPhoto,
      ];
      this.formData.completedPhoto = [
        ...this.completedPhoto,
      ];
      this.formData.acceptancePhoto = [
          ...this.acceptancePhoto,
      ];
      const msg = this.id ? "修改报案" : "添加报案";
      // insBillId 如果是0是新增、编辑
      let query = await this.$api.post(
        "/admin/accident/save",
        { ...this.formData, id: this.id || 0 },
        msg
      );
      if(query.code == 10000){
        this.$router.push({
          path: "/accident/log",
        });
      }
      
    },
    // 重置表单
    async resetInfo() {
      const res = await this.$confirm("重置将会清空您填的数据，是否确认？");
      if (res !== "confirm") return;
      this.formData = {};
      this.accidentPhoto = [];
      this.repairPhoto = [];
      this.completedPhoto = [];
      this.acceptancePhoto = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;

  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 10px;
    margin-bottom: 20px;

    .header-inner {
      width: 40%;
      display: flex;
      align-items: center;

      .content {
        flex: 1;
      }
    }
  }

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-content: center;

    .panel-header-text {
      .icon {
        color: #666;
        margin-right: 10px;
      }
    }
  }

  .panel-form {
    padding: 20px;
  }

  .base-info {
    padding: 15px;
  }

  .card-info {
    margin-top: 15px;
  }

  .collapse-title {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;

    .title-left {
      display: flex;
      align-items: center;
      color: #666;

      .icon {
        margin-right: 5px;
        margin-top: 3px;
      }
    }

    .title-right {
      margin-right: 10px;
    }
  }

  /deep/.el-card {
    margin-bottom: 15px;
  }

  /deep/.el-card__header {
    padding: 10px;
  }

  /deep/.el-card__body {
    padding: 15px;
  }
}

.select-btn {
  margin-bottom: 15px;
}

.page /deep/.el-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    display: flex;

    .el-form-item__label {
      flex-shrink: 0;
    }

    .el-form-item__content {
      flex: 1;
    }
  }

  .el-input {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 100%;
  }
}

.from-item--30 {
  width: 30%;
}

.from-item--10 {
  width: 100%;
}

.has-btn {
  /deep/.el-form-item__content {
    display: flex;
  }
}

.from-item--100 {
  width: 100%;
}

.confirm {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.enc {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .encTitle {
    &>span {
      margin-left: 15px;
      font-size: 16px;
      color: #666;
    }
  }

  .encNum {
    font-size: 14px;
    color: #666;

    &>span {
      color: red;
      margin-right: 4px;
    }
  }

  .drawer-content {
    width: 100%;
    height: 100%;
  }
}

.input-wrap {
  display: flex;
  align-items: center;

  /deep/ .el-input {
    width: 90px;
    margin-left: 10px;
  }
}

.panel-detail-footer {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;

  .panel-detail-footer-left {
    display: flex;
    align-items: center;

    .label {
      white-space: nowrap;
    }
  }
}

.img-list {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .eg-img {
    // width: 100px;
    // height: 100px;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: flex-start;
  }
}

/deep/.el-icon-circle-close {
  color: #ef6027;
}
</style>
